export default "__VITE_ASSET__f9fa6fdd__"